import data from '@emoji-mart/data'
import germanTranslations from '@emoji-mart/data/i18n/de.json'
import englishTranslations from '@emoji-mart/data/i18n/en.json'
import Picker from '@emoji-mart/react'
import {ClickAwayListener, IconButton, Popper} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {FC, useRef, useState} from 'react'
import {useLocale, useTranslate} from 'react-admin'

import {EmojiToolbarIcon} from '../../icons'

const EmojiPickerButton: FC<EmojiPickerButtonProps> = ({disabled, onSelect}) => {
  const styles = useStyles()
  const anchorElementRef = useRef<HTMLButtonElement>(null)
  const [isShowingEmojis, setIsShowingEmojis] = useState(false)
  const emojiTranslations = {
    de: germanTranslations, en: englishTranslations,
  }[useLocale()] as Record<string, any>
  return (
    <>
      <IconButton
        className={styles.emojiButton}
        disabled={disabled}
        onClick={() => setIsShowingEmojis(s => !s)}
        ref={anchorElementRef}
      >
        <EmojiToolbarIcon color="primary" />
      </IconButton>
      <Popper
        anchorEl={anchorElementRef.current}
        className={styles.emojiPopper}
        onClick={e => e.stopPropagation()}
        open={isShowingEmojis}
        placement="top"
      >
        <ClickAwayListener onClickAway={() => setIsShowingEmojis(false)}>
          <div>
            <Picker
              autoFocus
              data={data}
              i18n={{
                ...emojiTranslations,
                categories: {
                  ...emojiTranslations.categories,
                  frequent: useTranslate()('chat.toolbar.emojiPickerButton.recent'),
                  search: useTranslate()('chat.toolbar.emojiPickerButton.searchResults'),
                },
                search: useTranslate()('chat.toolbar.emojiPickerButton.search'),
              }}
              onEmojiSelect={emoji => {
                onSelect(emoji.native)
                setIsShowingEmojis(false)
              }}
              previewEmoji="grinning"
              previewPosition="top"
              searchPosition="sticky"
            />
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

const useStyles = makeStyles(() => ({
  emojiButton: {
    marginRight: '0.3rem',
  },
  emojiPopper: {
    zIndex: 1002,
  },
}))

interface EmojiPickerButtonProps {
  disabled?: boolean
  onSelect: (emoji: string) => void
}

export default EmojiPickerButton
